<template>
    <html>
        <body class="ovrflow desk_bckgnd_img_login">
            <header class="desk_display common--header header--overide">
                <b-row class="row_lr_margin">
                    <b-col cols="10" v-if="store.isLogoAvailable">
                        <img :src="store.groupDetail.cssp" alt class="img-responsive-class" style='max-height:70px;'/>
                    </b-col>
                    <b-col cols="10" v-if="!store.isLogoAvailable">
                        <div class="init-header-title">{{ store.groupDetail.gnm }}</div>
                    </b-col>
                </b-row>
            </header>
            <b-container class="bv-example-row cont_height mob_col_padding">
                <b-row class="justify-content-md-center dev_lr_margin row_height">
                    <b-col lg="5" class="mob_col_padding dev_position">
                        <div class="college_main_div">
                            <b-container class="brand--logo">
                                <b-row>
                                    <b-col cols="2" class="text-left">
                                        <div class="bck-btn">
                                            <b-button type="Back" variant="outline-light" v-on:click="backAction">
                                                <img src="images/back_blue.png" />
                                            </b-button>
                                        </div>
                                    </b-col>
                                    <b-col class="mob-display" cols="8" v-if="store.isLogoAvailable">
                                        <div class="text-center">
                                            <img :src="store.groupDetail.cssp" alt class="img-responsive-class" />
                                        </div>
                                    </b-col>
                                    <b-col class="mob-display" cols="8" v-if="!store.isLogoAvailable">
                                        <div class="text-center">
                                            <p class="init-header-title">{{ store.groupDetail.gnm }}</p>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-container>
                            <b-container>
                                <b-row>
                                    <b-col>
                                        <div class="register_form">
                                            <b-form>
                                                <b-container>
                                                    <b-row>
                                                        <b-col>
                                                            <h5 class="title_text">REGISTER</h5>
                                                        </b-col>
                                                    </b-row>
                                                    <div>
                                                        <input
                                                            class="inputstyle"
                                                            id="input-1"
                                                            placeholder="Email Address"
                                                            type="email"
                                                            v-model="register.eml"
                                                            autocomplete="off"
                                                            required
                                                        />
                                                        <!-- TODO -->
                                                        <!-- <input
                    class="mobileinputstyle"
                    id="input-2"
                    placeholder="Mobile Number (Optional)"
                    type="number"
                    v-model="register.mob"
                    maxlength="11"
                    autocomplete="off"
                    oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                    required
                  />
                          <label class="phoneStaticMsg">{{ this.mobilenumberformat }}</label>-->
                                                    </div>
                                                    <div class="continue-btn">
                                                        <b-row class="justify-content-md-center">
                                                            <b-col lg="10">
                                                                <b-button
                                                                    class="desk-continue-btn"
                                                                    type="contine"
                                                                    v-on:click="onContinue"
                                                                    variant
                                                                >
                                                                    {{ this.continue }}
                                                                </b-button>
                                                            </b-col>
                                                        </b-row>
                                                        <br />
                                                        <br />
                                                        <label v-if="errorStatus" class="register_errorMessageLabel" id="errorLabel">{{
                                                            errorMessage
                                                        }}</label>
                                                    </div>
                                                </b-container>
                                            </b-form>
                                        </div>
                                    </b-col>
                                </b-row>
                            </b-container>
                        </div>
                    </b-col>
                </b-row>
            </b-container>
            <Footer></Footer>
        </body>
    </html>
</template>

<script>
import apiCall from "@/services/api/apicall";
import { store } from "@/store.js";
import Footer from "@/components/footer";

export default {
    name: "Home",
    components: {
        Footer,
    },
    data() {
        return {
            store: store,
            //To Handle validation of the fields
            register: {
                grgcd: store.enteredGID,
                eml: "",
                mob: "",
                name: "",
            },
            // TODO
            // //Added form to add 1 only to the parameter for the API call
            // form: {
            //   grgcd: store.enteredGID,
            //   eml: "",
            //   mob: "",
            // },
            errorStatus: false,
            errorMessage: "",
            reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        };
    },

    mounted() {

    },

    methods: {
        onContinue(evt) {
            evt.preventDefault();
            if (navigator.onLine) {
                if (!this.reg.test(this.register.eml)) {
                    this.errorStatus = true;
                    this.errorMessage = "Please, enter email address";
                }
                //TODO
                //else if (this.register.eml.length > 0 && this.register.mob.length >= 11) {
                else if (this.register.eml.length > 0) {
                    if (!this.reg.test(this.register.eml)) {
                        this.errorStatus = true;
                        this.errorMessage = "Email-ID is not valid";
                    } else {
                        // TODO
                        // this.form.eml = this.register.eml;
                        // this.form.mob = "1" + this.register.mob;

                        // var headers = [
                        //         {
                        //             key: "Content-Type",
                        //             value: "application/json",
                        //             type: "text",
                        //         },
                        //     ];

                        // console.log("VERIFY", this.register);

                        apiCall
                            .apiServiceCall("Post", "", "/user/verify", this.register, {})
                            .then((response) => {
                                console.log('RESPONSE', response);
                                if (response.data.status == 1) {
                                    this.store.registration.iid = response.data.data.iid;
                                    this.store.registration.eml = this.register.eml;
                                    this.store.registration.mob = this.register.mob;
                                    this.$router.push({ path: "/otp" });
                                } else {
                                    this.errorStatus = true;
                                    this.errorMessage = response.data.message.err_msg;
                                }
                            })
                            .catch((error) => {
                                console.log('ERROR', error);

                                if (error.response.status == 500) {
                                    this.errorStatus = true;
                                    this.errorMessage = this.serverProblem;
                                } else if (error.response.status == 401) {
                                    setTimeout(() => this.$router.push({ path: "/home" }), 2000);
                                } else if (error.response.status == 504) {
                                    this.signout();
                                } else {
                                    this.errorStatus = true;
                                    this.errorMessage = error.response.data.message;
                                }
                            })
                            .catch(err => {
                                console.log('ERROR', err);
                                this.errorStatus = true;
                                this.errorMessage = 'Something wrong!';
                            });
                    }
                } else {
                    //TODO
                    //if (this.register.eml.length == 0 && this.register.mob.length == 0) {
                    if (this.register.eml.length == 0) {
                        this.errorStatus = true;
                        this.errorMessage = "Email-ID and Password field cannot be empty";
                    } else if (this.register.eml.length == 0) {
                        this.errorStatus = true;
                        this.errorMessage = "Email-ID cannot be empty";
                    }
                    //TODO
                    // else if (this.register.mob.length < 11) {
                    //   this.errorStatus = true;
                    //   this.errorMessage = "Cell number is not valid";
                    // }
                    else {
                        this.errorStatus = true;
                        this.errorMessage = "Cell number cannot be empty";
                    }
                }
            } else {
                this.errorStatus = true;
                this.errorMessage = this.checkInternetConnection;
            }
        },
        backAction() {
            this.$router.push({ path: "/groupID" });
        },
    },
};
</script>
